import React, { Component } from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import Header from "../../components/Header";
import Form from "./Form";

class DndForm extends Component {
  static propTypes = {
    // Injected by React-Router
    history: PropTypes.object.isRequired
  };

  model = "dnd";

  render = () => {
    const { history } = this.props;
    return (
      <article className="thirteen wide column">
        <Header title="Add DND" />
        <Form onCancel={() => history.goBack()} />
      </article>
    );
  };
}

export default withRouter(DndForm);
